var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2473 0.020752C0.907932 0.020752 0.632818 0.295865 0.632818 0.635235V1.87602C0.632811 1.87781 0.632811 1.87959 0.632818 1.88138V11.3595C0.632818 11.6989 0.907932 11.974 1.2473 11.974H14.0286C14.3679 11.974 14.643 11.6989 14.643 11.3595V1.88383C14.6431 1.88041 14.6431 1.87699 14.643 1.87357V0.635235C14.643 0.295865 14.3679 0.020752 14.0286 0.020752H1.2473ZM13.4141 1.59353V1.24972H1.86178V1.59351L7.40009 6.26726L7.40013 6.26729C7.46665 6.32344 7.55089 6.35423 7.63793 6.35423C7.72498 6.35423 7.80922 6.32344 7.87574 6.26729L7.87578 6.26726L13.4141 1.59353ZM1.86178 3.20161V10.745H13.4141V3.20162L8.66842 7.20645C8.38017 7.44974 8.01513 7.5832 7.63793 7.5832C7.26073 7.5832 6.8957 7.44974 6.60745 7.20645L1.86178 3.20161Z",
    fill: "black",
    fillOpacity: 0.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bc912aa9916dc3ac097d8bd4dcf74355.svg";
export { ForwardRef as ReactComponent };